module.exports = __webpack_public_path__ + "media/application/images/2018/2018-accordian-arrow-c2dae29a91b6adba72244151dae82fe1.svg";